/**
 * Formats a Shopify price integer (cents) using the store's money format.
 * Uses window.Shopify.moneyFormat set by the theme.
 *
 * @param {number} cents
 * @param {string} [format] - override format string, defaults to window.Shopify.moneyFormat
 * @returns {string}
 */

function formatMoney(cents, format) {
  const moneyFormat = format || window.Shopify.moneyFormat || '${{amount}}';

  if (typeof cents === 'string') cents = cents.replace('.', '');
  cents = parseInt(cents, 10);

  const value = (cents / 100).toFixed(2);
  const amountNoDecimals = Math.floor(cents / 100).toString();
  const amountWithCommasSeparator = (cents / 100)
    .toFixed(2)
    .replace(/\d(?=(\d{3})+\.)/g, '$&,');
  const amountNoDecimalsWithCommasSeparator = Math.floor(cents / 100)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');


    console.log(cents)

  return moneyFormat
    .replace('{{amount}}', amountWithCommasSeparator)
    .replace('{{amount_no_decimals}}', amountNoDecimalsWithCommasSeparator)
    .replace('{{amount_with_comma_separator}}', value.replace('.', ','))
    .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
    .replace('{{amount_with_apostrophe_separator}}', value.replace(/\d(?=(\d{3})+\.)/g, "$&'"));
}

/**
 * "Show total price only" is a per-product block setting on the New Free Gift block.
 * The widget snippet exposes it as window.SubscriptionTotalPriceOnly and as a data attribute
 * (the attribute is the fallback in case this script runs before the inline script).
 *
 * @returns {boolean}
 */
function isTotalPriceOnly() {
    if (typeof window.SubscriptionTotalPriceOnly === 'boolean') {
        return window.SubscriptionTotalPriceOnly;
    }

    const widget = document.querySelector('.subscription-widget[data-total-price-only]');
    return widget ? widget.dataset.totalPriceOnly === 'true' : false;
}

function toNumber(price) {
    if(!price){
        return 0;
    }
    
    return parseFloat(price);
}

function format(price) {
    // const noRound = Math.floor(price * 100) / 100;
    return formatMoney(price*100)
    // return `£${noRound}`;
}

function PriceText(id){
    var subscriptionPrice = window.SubscriptionWidgetConfig ? window.SubscriptionWidgetConfig.formattedPrices[parseInt(id)]: "";

    console.log(subscriptionPrice);

    if (subscriptionPrice != "") {
        document.querySelector(".option-box .price .old").textContent = subscriptionPrice.unit;
        document.querySelectorAll(".option-box .price .new")[1].textContent = subscriptionPrice.unit.replace(".98", ".99");
        document.querySelector(".option-box .price .new").textContent = subscriptionPrice.discounted.replace(".98", ".99");   
    }
    
    var option_price_per_day = "";
    var option_price_per_bottle = "";
    var option_gift_price = "";
    var option_delivery = "";
    var option_subscription_text = "";
    var option_onetime_text = "";
    var subscription_widget_badge_text = "";
    var discount_onetime= "";
    var price_onetime = "";
    var option_image = "";
    var option_index = "";
    
    document.querySelectorAll(".gift-container").forEach(function(gift){
        var giftId = gift.getAttribute("data-id");
        gift.classList.add("hide");
        if (giftId == id) {
            gift.classList.remove("hide");
        }
    })

    var widget = document.querySelector("recharge-subscription-widget");
    if(widget && widget.shadowRoot && widget.shadowRoot.querySelector(".rc-purchase-option__input:checked") && widget.shadowRoot.querySelector(".rc-purchase-option__input:checked").value == 'onetime'){
        // document.querySelectorAll(".gift-container").forEach(function(gift){
        //     gift.classList.add("hide");
        // });
  
        document.querySelector(".oneTimeSubscriptionOption") ? document.querySelector(".oneTimeSubscriptionOption").classList.remove("hide"): "";
    }

    document.querySelectorAll(".variant-picker__option-values input:checked").forEach(function(input){
        option_price_per_day = input.nextElementSibling.querySelector(".option_price_per_day").textContent != "" ? "(" + input.nextElementSibling.querySelector(".option_price_per_day").textContent + ")": "";
        option_price_per_bottle = input.nextElementSibling.getAttribute("data-price-per-bottle");
        option_gift_price = input.nextElementSibling.getAttribute("data-gift-price");
        option_subscription_text = input.nextElementSibling.getAttribute("data-subscription");
        option_onetime_text = input.nextElementSibling.getAttribute("data-onetime");
        option_delivery = input.nextElementSibling.getAttribute("data-delivery");
        subscription_widget_badge_text = input.nextElementSibling.getAttribute("data-subscription-badge");
        discount_onetime = input.nextElementSibling.getAttribute("data-discount-onetime");;
        price_onetime = input.nextElementSibling.getAttribute("data-price-onetime");
        option_image = input.nextElementSibling.getAttribute("data-image");
        option_sub_image = input.nextElementSibling.getAttribute("data-sub-image");
        option_index = input.getAttribute("data-main-index");
    })

    if (option_image != "") {
        var checkSub = document.querySelector('[name="purchase-type"]:checked').value;
        document.querySelectorAll(".main-media-image img").forEach(function(img){
            if (checkSub == 'onetime') {
                img.setAttribute("src", option_image);
                img.setAttribute("srcset", option_image);
            }else{
                img.setAttribute("src", option_sub_image);
                img.setAttribute("srcset", option_sub_image);
            }
            
            setTimeout(() => {
                img.parentElement.click();    
            }, 10);
        })
    }
    
    var priceFormate = window.SubscriptionWidgetConfig.formattedPrices[parseInt(id)];
    var unit = priceFormate.unit;
    var discounted = priceFormate.discounted;


    const unitValue = toNumber(priceFormate.unit.replace(/[^\d]/g, '')/100);
    const discountedValue = toNumber(priceFormate.discounted.replace(/[^\d]/g, '')/100);
    const saleValue = toNumber(window.PVaraints[option_index - 1].com_price);

    // "each" price is derived by dividing the pack total by the option's POSITION in the
    // variant picker (1st option = 1 unit, 2nd = 2 units, 3rd = 3 units). That only holds for
    // multi-pack products. Products whose options are different SIZES (NMN Powder: 15g / 30g /
    // 100g) have no per-unit meaning, so the "Show total price only" block setting turns the
    // division off and shows the full price of the selected size instead.
    const totalPriceOnly = isTotalPriceOnly();
    const divisor = totalPriceOnly ? 1 : Number(option_index);

    console.log(unit.replace(/[^\d]/g, ''), discounted.replace(/[^\d]/g, ''))

    const unitPrice = format(unitValue/divisor);
    const discountedPrice = format(discountedValue/divisor);
    const salePrice = format(saleValue/divisor);


    // Variants without a compare-at price come through as "" -> 0. Compare numerically: the
    // money format is "£{{amount}}", so zero renders as "£0.00" and never equals "£0".
    const hasCompareAt = saleValue > 0;

    if(totalPriceOnly){
        // Subscribe box: compare-at price crossed out (RRP), else the one-time price as anchor.
        document.querySelector(".option-box .price .old").textContent = hasCompareAt ? salePrice : unit;
        document.querySelector(".option-box .price .new").textContent = discounted;
        document.querySelectorAll('.price .second-part').forEach(secondPart => {
            secondPart.style.display = 'none';
        });
    }else if(Number(option_index) !== 0){
        document.querySelector(".option-box .price .old").textContent = window.firstVaraintPrice;
        document.querySelectorAll(".option-box .price .new")[1].textContent = unitPrice.replace(".98", ".99");
        document.querySelector(".option-box .price .new").textContent = discountedPrice.replace(".98", ".99");
        document.querySelectorAll('.price .second-part').forEach(secondPart => {
            secondPart.style.display = 'block';
        });
    }else {
        document.querySelectorAll('.price .second-part').forEach(secondPart => {
            secondPart.style.display = 'none';
        });
    }

    document.querySelector(".option-box .price .total_sub").textContent = discounted;
    document.querySelector(".option-box .price .total_one_time").textContent = unit;


      ///. discount /////
    const discount = parseFloat(discount_onetime) || 0;
    const oneTimePrice = unitValue * (1 - discount / 100);

    function force99(price) {
        return price.replace(/\.\d{2}$/, ".99");
    }

    if(totalPriceOnly){
        // No per-unit split — show the selected size's full one-time price as-is.
        document.querySelectorAll(".option-box .price .new")[1].textContent = discount ? force99(format(oneTimePrice)) : unit;
    }else {
        document.querySelectorAll(".option-box .price .new")[1].textContent = force99(format(oneTimePrice / divisor));
    }

    ///end discount /////

    const oldOneTimeEl = document.querySelector(".option-box .price .old-one-time");
    // Don't strike out a price identical to the one being charged.
    const showOneTimeCompareAt = hasCompareAt && salePrice !== unit;

    oldOneTimeEl.textContent = showOneTimeCompareAt ? salePrice : "";

    // The markup ships this span hidden. Only "total price only" products reveal it, so that the
    // one-time box can show its RRP crossed out — every other product keeps its current look.
    if(totalPriceOnly){
        oldOneTimeEl.style.display = showOneTimeCompareAt ? "" : "none";
    }

    var subscriptionPrice = document.querySelector("recharge-subscription-widget").shadowRoot.querySelector(".rc-purchase-option__subscription");

    var subscriptionHTML = "";

    if (option_subscription_text != "") {
        var option_subscription_texts = option_subscription_text.split("||")
        for (let i = 0; i < option_subscription_texts.length; i++) {
            const element = option_subscription_texts[i];
            subscriptionHTML = subscriptionHTML + "<li>"+ element +"</li>"
        }
    }

    window.oneTimeHTML = "";

    if (option_onetime_text != "") {
        var option_onetime_texts = option_onetime_text.split("||")
        for (let i = 0; i < option_onetime_texts.length; i++) {
            const element = option_onetime_texts[i];
            window.oneTimeHTML = window.oneTimeHTML + "<li>"+ element +"</li>"
        }
    }

    setTimeout(() => {    
        var ul = document.querySelector(".benefits");
        if (subscriptionHTML != "" && ul != "") {
            ul ? ul.innerHTML = subscriptionHTML: "";
        }

        var ul2 = document.querySelectorAll(".benefits")[1];
        if (window.oneTimeHTML != "" && ul2 != "") {
            ul2 ? ul2.innerHTML = window.oneTimeHTML: "";
        }

        var subscription_widget_badge = document.querySelector(".header-new .tag");
        subscription_widget_badge && subscription_widget_badge_text != "" ? subscription_widget_badge.textContent = subscription_widget_badge_text : "";
        
    }, 100);
}

document.querySelector("[name='id']").addEventListener("change", function(){
    var id = this.value;
    PriceText(id) 
});

var subscriptionWidget = setInterval(() => {
    var widget = document.querySelector("recharge-subscription-widget");
    if (widget) {
        
        var id = document.querySelector("[name='id']").value;
        var subscription = widget.shadowRoot.querySelector(".rc-purchase-option__subscription");
        var oneTime = widget.shadowRoot.querySelector(".rc-selection__onetime");
        widget.shadowRoot.querySelector("rc-selling-plans") ? widget.shadowRoot.querySelector("rc-selling-plans").style.display = 'none': "";
        subscription ? subscription.style.background = "#f5f5f5": "";

        subscription ? subscription.addEventListener("click", function(){
            var id = document.querySelector("[name='id']").value;
            
            document.querySelectorAll(".gift-container").forEach(function(gift){
                var giftId = gift.getAttribute("data-id");
                gift.classList.add("hide");
                if (giftId == id) {
                    gift.classList.remove("hide");
                }
            });


            setTimeout(() => {
                var widget2 = document.querySelector("recharge-subscription-widget");
                widget2.shadowRoot.querySelector("rc-selling-plans") ? widget2.shadowRoot.querySelector("rc-selling-plans").style.display = 'none': "";
                PriceText(id);
            }, 100);
        }): "";

        oneTime ? oneTime.addEventListener("click", function(){
            var widget3 = document.querySelector("recharge-subscription-widget");
            
            widget3.shadowRoot.querySelector("rc-selling-plans") ? widget3.shadowRoot.querySelector("rc-selling-plans").style.display = 'none': "";
            // document.querySelectorAll(".gift-container").forEach(function(gift){
            //     gift.classList.add("hide");
            // });

            document.querySelector(".oneTimeSubscriptionOption") ? document.querySelector(".oneTimeSubscriptionOption").classList.remove("hide"): "";
            var id = document.querySelector("[name='id']").value;
            PriceText(id);

            // setTimeout(() => {         
            //     var ul2 = widget3.shadowRoot.querySelector("rc-onetime-drawbacks") ? widget3.shadowRoot.querySelector("rc-onetime-drawbacks").shadowRoot.querySelector("ul"): "";
            //     if (window.oneTimeHTML != "" && ul2 != "") {
            //         ul2 ? ul2.innerHTML = window.oneTimeHTML: "";
            //     }
            // }, 1000);
        }): "";
        PriceText(id);

        document.querySelectorAll(".variant-picker__option-values input")[1].click();

        clearInterval(subscriptionWidget);
    }
}, 1000);

async function addToCart(items) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            items: items
        }),
      });

      if (!response.ok) {
        throw new Error('Error adding to cart');
      }

      const data = await response.json();

      window.SLIDECART_UPDATE()

      // Display a success message
     
      
      console.log('Add to Cart Response:', data); // Debug log
    } catch (error) {
      // Display error message
      
      
      console.error('Add to Cart Error:', error);
    }
  }


// document.querySelectorAll(".add_to_cart_div [type='submit']").forEach(function(button){
//     button.addEventListener("click", function(e){
//         e.preventDefault();
//         var gifts = this.closest(".product-info__block-list").querySelectorAll(".gift-container:not(.hide) .single-gift-container.selected_product");
//         var qty = this.closest(".product-info__block-list").querySelector("[name='quantity']") 
//                   ? parseInt(this.closest(".product-info__block-list").querySelector("[name='quantity']").value) 
//                   :1;
//         // var id = parseInt(this.closest(".product-info__block-list").querySelector("[name='id']").value);
//         var items = [];

//         // items.push({
//         //     id: id,
//         //     quantity: qty
//         // });

//         gifts.forEach(function(gift){
//             var id = parseInt(gift.getAttribute("data-id"));
//             items.push({
//                 id: id,
//                 quantity: qty
//             })
//         })

//         console.log(items);
//         setTimeout(() => {
//             addToCart(items);    
//         }, 1000);
        
//     })
// })

function toggleSecondPart() {
    // "Total price only" products never show the separate "Total:" part — the main price row
    // already IS the total.
    if (isTotalPriceOnly()) {
        document.querySelectorAll('.price .second-part').forEach(el => {
            el.style.display = 'none';
        });
        return;
    }

    const selected = document.querySelector(
        'input[name="option1"]:checked'
    );

    const allVariants = [
        ...document.querySelectorAll('input[name="option1"]')
    ];

    const selectedIndex = allVariants.indexOf(selected);

    document.querySelectorAll('.price .second-part').forEach(el => {
        if (selectedIndex === 0) {
            el.style.display = 'none';
        } else {
            el.style.display = 'block';
        }
    });
}

// Initial load
toggleSecondPart();

// Variant change
document.addEventListener('change', function (e) {
    if (e.target.matches('input[name="option1"]')) {
        setTimeout(toggleSecondPart, 100);
    }
}); 

document.querySelectorAll('input[name="option1"]').forEach(input => {
    input.addEventListener('change', function () {

        const oneTimeLabel = document.querySelector('label[data-type="onetime"]');

        if (this.checked && this.value === '30 Days') {
            oneTimeLabel.style.display = 'block';
        } else {
            oneTimeLabel.style.display = 'none';
        }

    });
});